<template>
    <div>
        <transition name="slide">
            <b-card :header="captionImages">
                <b-form-checkbox-group stacked id="basicCustomCheckboxes">
                    <b-table
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive="sm"
                        :items="imagesArray"
                        :fields="fieldsAttachments"
                        :current-page="currentPage"
                        :per-page="perPage"
                    >
                        <template slot="thumb" slot-scope="data">
                            <a v-bind:href="data.item.thumbDownloadUrl"><b-img
                                v-bind:src="data.item.thumbDownloadUrl"
                                fluid
                                alt="Can't load img"
                            />
                            </a>
                        </template>
                        <template slot="title" slot-scope="data">
                            <strong>{{data.item.title}}</strong>
                        </template>
                        <template slot="description" slot-scope="data">
                            <strong>{{data.item.description}}</strong>
                        </template>
                        <template slot="viewButton" slot-scope="data">
                            <b-button :value="data.item" v-on:click="rowClickedRemove(data.item)" block variant="danger"><i class="fa fa-ban"></i>Remove</b-button>
                        </template>
                    </b-table>
                </b-form-checkbox-group>
                <nav>
                    <b-pagination
                        size="sm"
                        :total-rows="imagesArray.length"
                        :per-page="perPage"
                        v-model="currentPage"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    />
                    <b-row class="align-items-center">
                        <b-col cols="6" class="mb-3 mb-xl-0">
                            <b-button v-on:click="addImageButton" block variant="primary">Add Image</b-button>
                        </b-col>
                        <b-col cols="6" class="mb-3 mb-xl-0">
                            <b-button
                                v-if="imagesSelected.length > 0"
                                v-on:click="removeMembersButton"
                                block
                                variant="danger"
                            >Remove Attachment(s)</b-button>
                        </b-col>
                    </b-row>
                </nav>
            </b-card>
        </transition>
        <b-modal title="Add an image" class="modal-primary" v-model="imageModal" @ok="addImage">
            <b-form-group v-if="attachmentData.imageFile != null">
                <b-form-input
                    id="imageTitle"
                    type="text"
                    autocomplete="name"
                    v-model="attachmentData.title"
                    size="md"
                    placeholder="Enter image title..."
                ></b-form-input>
            </b-form-group>
            <b-form-group v-if="attachmentData.imageFile != null">
                <b-form-textarea
                    id="imageDescription"
                    v-model="attachmentData.description"
                    placeholder="Enter image description..."
                    :rows="3"
                    :max-rows="6"
                    size="sm"
                ></b-form-textarea>
            </b-form-group>
            <b-form-group
                label="Upload image"
                label-for="imageInput"
                :label-cols="3"
                :horizontal="true"
            >
                <b-form-file
                    accept="image/*"
                    id="imageInput"
                    :plain="true"
                    v-model="attachmentData.imageFile"
                ></b-form-file>
            </b-form-group>
            <b-form-group v-if="attachmentData.imageFile != null">
                <b-img v-bind:src="getImageFile()" fluid alt="Responsive image"/>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import _ from 'underscore'
import { db } from '@/config/devowqlo';
import { storage } from '@/config/devowqlo';
export default {
    name: "imageAttachment",
    props: {
        type: {
            type: String,
            default: ""
        },
        typeId: {
            type: String,
            default: ""
        },
        teamId: {
            type: String,
            default: ""
        },
        captionImages: {
            type: String,
            default: "Images"
        },
        hover: {
            type: Boolean,
            default: true
        },
        striped: {
            type: Boolean,
            default: true
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isEdit: false,
            currentTeam: null,
            attachmentData: {
                title: null,
                type: null,
                description: null,
                url: null,
                thumbUrl: null,
                imageFile: null
            },
            center: null,
            marker: null,
            teamsArray: [],
            teamsNamesArray: [],
            imagesArray: [],
            imagesSelected: [],
            imageModal: false,
            previewImage: null,
            previewImageUrl: null,
            fieldsAttachments: [
                // { key: "checkbox", label: "" },
                { key: "thumb" },
                { key: "title" },
                { key: "description" },
                { key: "viewButton", label: "Actions" }
            ],
            currentPage: 1,
            perPage: 5,
            totalRows: 0,
            KEY_TYPE_ATTACHMENT:  this.getKeyAttachment(),
            ST_TYPE_ATTACHMENT: this.getStAttachment(),
        };
    },
    created() {
        this.getImages()
        console.log("type: ", this.type);
        console.log("typeId: ", this.typeId);
        console.log("teamId: ", this.teamId);
        console.log("teamId: ", this.KEY_TYPE_ATTACHMENT);
    },
    methods: {
        addImageButton() {
            this.imageModal = true;
        },
        addImage() {
            const dateNow = Date.now();
            console.log("Uploading image...");
            const imageName =
                +new Date() + "-" + this.attachmentData.imageFile.name;
            const imageMetadata = {
                contentType: this.attachmentData.imageFile.type
            };
            // 1. Save Image on Storage
            const uploadTask = storage
                .ref()
                .child(this.ST_TYPE_ATTACHMENT)
                .child("Images")
                .child(imageName)
                .put(this.attachmentData.imageFile, imageMetadata)
                .then(snapshot => snapshot.ref.getDownloadURL())
                .then(url => {
                    const thumbImageUrl = "thumb_" + imageName;
                   
                   // 2. save on Database
                    var imageModel = {
                        title: this.attachmentData.title,
                        description: this.attachmentData.description,
                        type: "image",
                        url: imageName,
                        thumbUrl: thumbImageUrl,
                        created: dateNow
                    };
                    db.ref(this.KEY_TYPE_ATTACHMENT)
                        .child(this.teamId)
                        .child(this.typeId)
                        .child("images")
                        .push(imageModel);
                });
        },
        getImageFile() {
            console.log(this.attachmentData.imageFile);
            var reader = new FileReader();
            reader.onload = e => {
                this.previewImage = e.target.result;
            };
            reader.readAsDataURL(this.attachmentData.imageFile);
            return this.previewImage;
        }
        ,getImages (){
            db.ref(this.KEY_TYPE_ATTACHMENT)
                .child(this.teamId)
                .child(this.typeId)
                .child("images")
                .on('value', (snapshot) =>{

                this.imagesArray = []
                console.log(snapshot.val())
                snapshot.forEach(childSnapshot => {
                    console.log(childSnapshot)
                    var imageObject = childSnapshot.val()
                    imageObject.key = childSnapshot.key
                    storage.ref().child(this.ST_TYPE_ATTACHMENT).child('Images').child(imageObject.thumbUrl).getDownloadURL().then((url) => {
                        
                        Object.assign(imageObject, {thumbDownloadUrl: url});
                        this.imagesArray.push(imageObject)

                    }).catch(function(error) {
                        // Handle any errors
                    });
                })
            })
        },
        rowClickedRemove(data){
            db.ref(this.KEY_TYPE_ATTACHMENT)
                .child(this.teamId)
                .child(this.typeId)
                .child("images")
                .set(null)
        }, 
        // Aux functions
        getKeyAttachment(){
            if (this.type == "training") {
                return "trainingAttachments"
            } else if (this.type == "match"){
                return "matchAttachments"
            }
        },
        getStAttachment(){
            if (this.type == "training") {
                return "TrainingAttachments"
            } else if (this.type == "match"){
                return "MatchAttachments"
            }
        }
    }
};
</script>

<style scoped>
</style>